import { render } from "./ExchangeBanner.vue?vue&type=template&id=29f47f0c"
import script from "./ExchangeBanner.vue?vue&type=script&lang=js"
export * from "./ExchangeBanner.vue?vue&type=script&lang=js"

import "./ExchangeBanner.vue?vue&type=style&index=0&id=29f47f0c&lang=scss"

import exportComponent from "/codebuild/output/src3815826973/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__